import { Strings } from './Strings';

export type ModerationType = 'PROFANITY' | 'SENTIMENT';

export type ModerationAlertOption = {
  text: string;
  style?: 'default' | 'cancel' | 'destructive';
};

export type ModerationAlertConfig = {
  title: string;
  message: string;
  options: ModerationAlertOption[];
};
const strings = Strings.get()

export function getModerationAlertConfig(
  moderationType: ModerationType): ModerationAlertConfig {
  if (moderationType === 'PROFANITY') {
    return {
      title: strings.discussion.moderationAlerts.profanity.title,
      message: strings.discussion.moderationAlerts.profanity.message,
      options: [
        { text: strings.discussion.moderationAlerts.profanity.options.viewCodeOfConduct, style: 'default' },
        { text: strings.discussion.moderationAlerts.profanity.options.editPost, style: 'cancel' },
      ],
    };
  }

  return {
    title: strings.discussion.moderationAlerts.sentiment.title,
    message: strings.discussion.moderationAlerts.sentiment.message,
    options: [
      { text: strings.discussion.moderationAlerts.sentiment.options.sendAnyway, style: 'destructive' },
      { text: strings.discussion.moderationAlerts.sentiment.options.viewCodeOfConduct, style: 'default' },
      { text: strings.discussion.moderationAlerts.sentiment.options.editPost, style: 'cancel' },
    ],
  };
}


